import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Card } from 'react-bootstrap';
import Header from './Header';
import DeviceCards from './DeviceCards';
import { getDeviceList, unsubscribeEgDeviceKPI } from '../../../actions/farm-monitor';

const DeviceList = (props) => {
    const { farmId } = props;

    const [searchText, setSearchText] = useState("");

    useEffect(() => {
        if (!farmId) return;
        const params = { farmId: farmId };

        props.actions.getDeviceList(params);

        return () => props.actions.unsubscribeEgDeviceKPI();
    }, [farmId]);

    return <Card className="q-app-details" >
        <Header setSearchText={setSearchText} />
        <DeviceCards searchText={searchText} />
    </Card>
}

const mapStateToProps = state => {
    return ({
        farmId: state.farmMonitor.farmId
    });
}

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        getDeviceList, unsubscribeEgDeviceKPI
    }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(DeviceList);